import { faMapMarker } from '@fortawesome/pro-regular-svg-icons';
import { faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons';
import { KCFCheckbox } from 'components/checkbox/KCFCheckbox';
import { ILocationSummaryRow } from 'custom_hooks/data_hooks/data_source/locationAssetDataSource';
import {
    useCreateFavorite,
    useDeleteFavorite,
} from 'custom_hooks/data_hooks/favorites/useFavorites';

interface ILocationTableCheckProps {
    dataItem: ILocationSummaryRow;
}

export function LocationTableCheckbox({ dataItem }: ILocationTableCheckProps) {
    const { mutate: createFavorite } = useCreateFavorite();
    const { mutate: deleteFavorite } = useDeleteFavorite();

    const onLocationCheckChange = () => {
        if (dataItem.Location.LocationId) {
            if (dataItem.favorite) {
                deleteFavorite({
                    id: dataItem.Location.LocationId,
                    type: 'Location',
                });
            } else {
                createFavorite({
                    id: dataItem.Location.LocationId,
                    type: 'Location',
                });
            }
        }
    };

    return (
        <KCFCheckbox
            overrideIconOn={faMapMarkerAlt}
            overrideIconOff={faMapMarker}
            overrideIconOnClick={onLocationCheckChange}
            checked={dataItem.favorite ?? false}
            data-cy="location-table-checkbox"
        />
    );
}
